import { render, staticRenderFns } from "./UploadAttachment.vue?vue&type=template&id=75c2666f&"
import script from "./UploadAttachment.vue?vue&type=script&lang=js&"
export * from "./UploadAttachment.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttachment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/pixflow.app/httpdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('75c2666f', component.options)
    } else {
      api.reload('75c2666f', component.options)
    }
    module.hot.accept("./UploadAttachment.vue?vue&type=template&id=75c2666f&", function () {
      api.rerender('75c2666f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/UploadAttachment.vue"
export default component.exports